import React from "react";
import { intl } from "dmsbasereact";
import { ReportLayout } from "./components/ReportLayout";
import { useFormatters } from "../../hooks/useFormater";

export const PrescriptionsReportPage = () => {
    const formatters = useFormatters();

    /**
     * Header columns conforme sequência esperada em .ai_docs/reports.md
     */
    const header = [
        // 1. Código
        {
            label: intl.get("Reports.Prescriptions.Code").d("Code"),
            column_name: "code",
            width: "120px",
        },
        // 2. Data
        {
            label: intl.get("Reports.Prescriptions.Date").d("Date"),
            column_name: "prescription_date",
            width: "110px",
            function: (value) => (value ? new Date(value).toLocaleDateString("pt-BR") : "--"),
        },
        // 3. Paciente
        {
            label: intl.get("Reports.Prescriptions.Patient").d("Patient"),
            column_name: "patient_name",
            width: "200px",
        },
        // 4. Médico
        {
            label: intl.get("Reports.Prescriptions.Doctor").d("Doctor"),
            column_name: "doctor_name",
            width: "200px",
        },
        // 5. CRM
        {
            label: intl.get("Reports.Prescriptions.CRM").d("CRM"),
            column_name: "doctor_crm",
            width: "100px",
        },
        // 6. UF do CRM
        {
            label: intl.get("Reports.Prescriptions.DoctorState").d("CRM State"),
            column_name: "doctor_uf",
            width: "60px",
        },
        // 7. Instituição
        {
            label: intl.get("Reports.Prescriptions.Institution").d("Institution"),
            column_name: "institution_name",
            width: "200px",
        },
        // 8. CNPJ Instituição Prescritora
        {
            label: intl.get("Reports.Prescriptions.InstitutionCNPJ").d("Institution CNPJ"),
            column_name: "institution_cnpj",
            width: "150px",
            function: (value) => formatters.formatCNPJ(value),
        },
        // 9. Produto
        {
            label: intl.get("Reports.Prescriptions.Product").d("Product"),
            column_name: "product_name",
            width: "180px",
        },
        // 10. Quantidade (Posologia)
        {
            label: intl.get("Reports.Prescriptions.Posology").d("Posology"),
            column_name: "posology_desc",
            width: "150px",
        },
        // 11. Status
        {
            label: intl.get("Reports.Prescriptions.Status").d("Status"),
            column_name: "status",
            width: "120px",
            function: (value) => intl.get(`PrescriptionStatus.${value}`).d(value),
        },
    ];

    const filterFields = [
        { name: "code", label: intl.get("Code").d("Code"), type: "text" },
        {
            name: "patient_name",
            label: intl.get("Patient").d("Patient"),
            type: "text"
        },
        {
            name: "doctor_name",
            label: intl.get("Doctor").d("Doctor"),
            type: "text"
        },
        { name: "doctor_crm",
            label: intl.get("CRM").d("CRM"),
            type: "text" 
        },
        {
            name: "doctor_crm_state",
            label: intl.get("Reports.Prescriptions.FilterCRMState").d("CRM State"),
            type: "multiselect",
            optionsKey: "crm_state",
        },
        { name: "institution_name",
            label: intl.get("Institution").d("Institution"),
            type: "text" 
        },
        { name: "institution_cnpj",
            label: intl.get("CNPJ").d("CNPJ"),
            type: "text" 
        },
        { name: "status", label: intl.get("Status").d("Status"), type: "multiselect" },
    ];

    return (
        <ReportLayout
            title="Reports.Prescriptions.PageTitle"
            titleDefault="Prescriptions Report"
            manualSlug="reports-prescriptions"
            tableUrl="/reports/prescriptions/table"
            filterOptionsUrl="/reports/prescriptions/filter-options"
            exportUrl="/reports/prescriptions/export"
            header={header}
            filterFields={filterFields}
            dateFilterLabel={intl.get("Reports.DateFilter.PrescriptionDate").d("Prescription Date")}
        />
    );
};

export default PrescriptionsReportPage;
